const formatNumber = n => {
    n = n.toString()
    return n[1] ? n : `0${n}`
}

export default {
  /** 显示提示信息 */
  showToast(page) {
    page.showToast = true
    setTimeout(() => {
      page.showToast = false
    }, 3000)
  },
  formatTime(date) {
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    const hour = date.getHours()
    const minute = date.getMinutes()
    const second = date.getSeconds()

    return `${[year, month, day].map(formatNumber).join('-')} ${[hour, minute, second].map(formatNumber).join(':')}`
  },
  observe(target, callback) {
    let options = {
        root: null,
        rootMargin: '0px',
        threshold: 1.0 // 表示元素完全进入视口时触发
    };
    const observe = new IntersectionObserver(function(entries) {
      console.log(entries,'++++++++++++++++++++')
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                console.log("元素已进入视口");
                callback()
                // 在这里执行你的逻辑，如加载更多内容
            }
        })
    }, options)
    
    observe.observe(target)
    return observe
  }
}